import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";

import Actualites from "./AppliAdmin/Actualites/Actualites";
import MessagesSection from "./AppliAdmin/MessagesSection/MessagesSection";
import AlbumsPhotos from "./AppliAdmin/AlbumsPhotos/AlbumsPhotos";
import Agenda from "./AppliAdmin/Agenda/Agenda";
import Palmares from "./AppliAdmin/Palmares/Palmares";
import Section from "./AppliAdmin/Section/Section";
import UsersManager from "./AppliAdmin/UsersManager/UsersManager";
import Visites from "./AppliAdmin/Visites/Visites";
import InfrastructuresManager from "./AppliAdmin/Infrastructures/InfrastructuresManager";
import Groupes from "./AppliAdmin/Groupes/Groupes";
import SectionAdmin from "./AppliAdmin/SectionAdmin/SectionAdmin";
import Partenaires from "./AppliAdmin/Partenaires/Partenaires";
import TeamClub from "./AppliAdmin/Team/TeamClub";
import ParametresClub from "./AppliAdmin/SettingsAdmin/ParametresClub";
import ErrorPage from "../ErrorPage/ErrorPage";

const MainContent = ({ sectionId }) => {
  return (
    <div className="mx-auto w-full max-w-[1600px]">
      <div className="min-h-[calc(100vh-150px)] rounded-[2rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-slate-900 sm:p-5 lg:p-6">
        <Routes>
          <Route index element={<Navigate to="messages" replace />} />

          <Route
            path="messages"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <MessagesSection
                  key={`messages-${sectionId}`}
                  sectionId={sectionId}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="actualites"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Actualites
                  key={`actualites-${sectionId}`}
                  sectionId={sectionId}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="albums-photos"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <AlbumsPhotos
                  key={`albums-${sectionId}`}
                  sectionId={sectionId}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="groupes"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Groupes key={`groupes-${sectionId}`} sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="agenda"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Agenda key={`agenda-${sectionId}`} sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="palmares"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Palmares
                  key={`palmares-${sectionId}`}
                  sectionId={sectionId}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="section"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Section key={`section-${sectionId}`} sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="utilisateurs"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <UsersManager sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="sectionadmin"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <SectionAdmin sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="visites"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <Visites sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="infrastructures"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <InfrastructuresManager sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="partenaires"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <Partenaires sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="equipes"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <TeamClub sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route
            path="settingsadmin"
            element={
              <ProtectedRoute allowedRoles={[1]}>
                <ParametresClub sectionId={sectionId} />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </div>
  );
};

export default MainContent;